var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeypadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.143,
    height: 10.143,
    viewBox: "0 0 10.143 10.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_211765_keypad_icon",
    "data-name": "211765_keypad_icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M342.669,341.2a1.469,1.469,0,1,0,1.469,1.469A1.469,1.469,0,0,0,342.669,341.2Z",
    transform: "translate(-333.995 -333.996)",
    fill: "#2eb59e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M204.069,341.2a1.469,1.469,0,1,0,1.469,1.469A1.469,1.469,0,0,0,204.069,341.2Z",
    transform: "translate(-198.998 -333.996)",
    fill: "#2eb59e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M65.469,341.2a1.469,1.469,0,1,0,1.469,1.469A1.469,1.469,0,0,0,65.469,341.2Z",
    transform: "translate(-64 -333.996)",
    fill: "#2eb59e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M342.669,202.6a1.469,1.469,0,1,0,1.469,1.469A1.469,1.469,0,0,0,342.669,202.6Z",
    transform: "translate(-333.995 -198.998)",
    fill: "#2eb59e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M204.069,202.6a1.469,1.469,0,1,0,1.469,1.469A1.469,1.469,0,0,0,204.069,202.6Z",
    transform: "translate(-198.998 -198.998)",
    fill: "#2eb59e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M65.469,202.6a1.469,1.469,0,1,0,1.469,1.469A1.469,1.469,0,0,0,65.469,202.6Z",
    transform: "translate(-64 -198.998)",
    fill: "#2eb59e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M342.669,66.939a1.469,1.469,0,1,0-1.469-1.469A1.469,1.469,0,0,0,342.669,66.939Z",
    transform: "translate(-333.995 -64)",
    fill: "#2eb59e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M204.069,64a1.469,1.469,0,1,0,1.469,1.469A1.469,1.469,0,0,0,204.069,64Z",
    transform: "translate(-198.998 -64)",
    fill: "#2eb59e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M65.469,64a1.469,1.469,0,1,0,1.469,1.469A1.469,1.469,0,0,0,65.469,64Z",
    transform: "translate(-64 -64)",
    fill: "#2eb59e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeypadIcon);
export default __webpack_public_path__ + "static/media/keypad_icon.155ae8efdec4ad171bb01c5463b6d5e4.svg";
export { ForwardRef as ReactComponent };